import { FormikProps } from "formik";
import { get, isEmpty, isNil, isUndefined, omit } from "lodash-es";

export const setApiErrors = (form: FormikProps<any>, apiErrors: any) => {
  const status = form.status;
  form.setStatus({ ...status, apiErrors });
};

export const getApiErrors = (form?: FormikProps<any>) => {
  return form && form.status && form.status.apiErrors;
};

export const getLocalError = (form: FormikProps<any>, name: string) => {
  return get(form && form.errors, name);
};

export const getApiError = (form: FormikProps<any>, name: string) => {
  const errors = getApiErrors(form);
  return errors && errors[name];
};

export const isFieldValid = (form: FormikProps<any>, name: string) => {
  const localError = getLocalError(form, name);
  const apiError = getApiError(form, name);

  return isUndefined(localError) && isUndefined(apiError);
};

export const isErrorVisible = (form: FormikProps<any>, name: string) => {
  const touched = get(form && form.touched, name);
  const submitted = form ? form.submitCount > 0 : false;

  return !isFieldValid(form, name) && (touched || submitted);
};

export const isFormValid = (form: FormikProps<any>) => {
  const apiErrors = getApiErrors(form);
  return isEmpty(form.errors) && isEmpty(apiErrors);
};

export const clearApiError = (form: FormikProps<any>, name: string) => {
  const apiError = getApiError(form, name);

  if (!isNil(apiError)) {
    const apiErrors = omit(getApiErrors(form), name);
    setApiErrors(form, apiErrors);
  }
};
